import styled from "styled-components";

export const ActivityLogContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px;
  gap: 24px;
`;

export const UserCellContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

export const UserInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
`;

export const UserNameText = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => props.theme?.colors?.text || "#000"};
`;

export const ScopeContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const VisibilityContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  
  span {
    font-size: 14px;
    color: ${(props) => props.theme?.colors?.text || "#000"};
  }
`;

export const StatusContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  
  span {
    font-size: 14px;
    font-weight: 500;
  }
`;

